import React, { useEffect, useState } from 'react'
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import ptLocale from '@fullcalendar/core/locales/pt-br'
import interactionPlugin from "@fullcalendar/interaction"
import { useHistory } from 'react-router-dom'
import api from '../components/api'


const Calendario = () => {

    const history = useHistory()

    var [eventos, setEventos] = useState()


    async function carregaEventos() {

        await api.get('eventosCalendar').then((result) => {

            //console.log(result.data)
            setEventos(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        /*
        setEventos([
            { title: 'Seminário Hospitais Saudáveis', color: 'green', start: '2022-02-01', end: '2022-02-05', id: 3 },
            { title: 'I Seminário Saúde Sem Mercúrio em Brasília', start: '2022-02-02', end: '2022-02-04', id: 1 }
        ])
        */

        carregaEventos()

    }, [])


    return (

        <div>


            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-date'></i>
                </div>
                <div class='header-title'>
                    <h1>Eventos</h1>
                    <small>Calendário</small>
                    
                </div>
            </div>



            <FullCalendar
                locale={ptLocale} 
                plugins={[ dayGridPlugin, interactionPlugin ]}
                initialView="dayGridMonth"
                events={eventos}
                displayEventTime={false}
                eventClick={
                    function(arg){
                        
                        //alert(arg.event.title)
                        //alert(arg.event.id)
                        history.push(`/Evento/${arg.event.id}`)
                    }
                }
                                                        
            />



        </div>

    )

}

export default Calendario